export const GIAOHANG_LIST_INITING             = 'GIAOHANG_LIST_INITING'
export const GIAOHANG_LIST_REQUESTING          = 'GIAOHANG_LIST_REQUESTING'
export const GIAOHANG_LIST_SUCCESS             = 'GIAOHANG_LIST_SUCCESS'
export const GIAOHANG_LIST_ERROR               = 'GIAOHANG_LIST_ERROR'

export const GIAOHANG_HISTORY_LIST_INITING             = 'GIAOHANG_HISTORY_LIST_INITING'
export const GIAOHANG_HISTORY_LIST_REQUESTING          = 'GIAOHANG_HISTORY_LIST_REQUESTING'
export const GIAOHANG_HISTORY_LIST_SUCCESS             = 'GIAOHANG_HISTORY_LIST_SUCCESS'
export const GIAOHANG_HISTORY_LIST_ERROR               = 'GIAOHANG_HISTORY_LIST_ERROR'

export const GIAOHANG_DETAIL_INITING           = 'GIAOHANG_DETAIL_INITING'
export const GIAOHANG_DETAIL_REQUESTING        = 'GIAOHANG_DETAIL_REQUESTING'
export const GIAOHANG_DETAIL_SUCCESS           = 'GIAOHANG_DETAIL_SUCCESS'
export const GIAOHANG_DETAIL_ERROR             = 'GIAOHANG_DETAIL_ERROR'   

export const GIAOHANG_UPDATE_REQUESTING        = 'GIAOHANG_UPDATE_REQUESTING'
export const GIAOHANG_UPDATE_SUCCESS           = 'GIAOHANG_UPDATE_SUCCESS'
export const GIAOHANG_UPDATE_ERROR             = 'GIAOHANG_UPDATE_ERROR'   

export const GIAOHANG_LIST_NV_REQUESTING       = 'GIAOHANG_LIST_NV_REQUESTING'
export const GIAOHANG_LIST_NV_SUCCESS          = 'GIAOHANG_LIST_NV_SUCCESS'
export const GIAOHANG_LIST_NV_ERROR            = 'GIAOHANG_LIST_NV_ERROR'

export const GIAOHANG_EXPORT_XLS_INITING       = 'GIAOHANG_EXPORT_XLS_INITING'
export const GIAOHANG_EXPORT_XLS_REQUESTING    = 'GIAOHANG_EXPORT_XLS_REQUESTING'
export const GIAOHANG_EXPORT_XLS_SUCCESS       = 'GIAOHANG_EXPORT_XLS_SUCCESS'
export const GIAOHANG_EXPORT_XLS_ERROR         = 'GIAOHANG_EXPORT_XLS_ERROR'

export const GIAOHANG_DETAIL_API               = '/api/v1/giaohang/get_donhang'  
export const GIAOHANG_LIST_API                 = '/api/v1/giaohang/giaohang_list_by_store'
export const GIAOHANG_HISTORY_LIST_API         = '/api/v1/giaohang/giaohang_lich_su_by_order'   
export const GIAOHANG_UPDATE_API               = '/api/v1/giaohang/giaohang_update'  
export const GIAOHANG_LIST_NV_API              = '/api/v1/giaohang/nhanvien_giaohang_list_by_store'
export const GIAOHANG_EXPORT_API               = '/api/v1/giaohang/giaohang_export_by_store'


// WEBPACK FOOTER //
// ./src/views/GiaoHang/constants.js